import React from "react";
import chetan from "./chetan.jpg";
import "./navbar.css";
import Cheteanresume from "./Chetanresume.doc";


const AboutPage = () => {
  return (
    <>
    <div className="about-content-heading">
        <h1>About Me</h1>
        <p>What i am</p>
    </div>
      <div className="about-content">
        <div className="about-content-image">
          <img src={chetan} alt="MyPhoto" height="440px" />
        </div>
        <div className="about-content-text">
          <h1>I'm Chetan</h1>
          <p>
            Hey there, I am a passionate web developer and UI/UX designer with a
            keen interest in taking up that as my career. I have the expertise
            from hacker rank and LinkedIn for the frontend web development and
            programming languages. I am a self-taught freelancer capable of
            building responsive websites with great design. I'm incredibly
            passionate about two things: The three responses to a piece of
            design - yes, no, and WOW! " Wow is the one I aim for " The second
            is personal development. Every day I strive to learn something new
            and become a better version of myself.
          </p>
          <a href={Cheteanresume} target='blank'>Download Cv</a>
        </div>
      </div>
    </>
  );
};
export default AboutPage;
